import { default as Title } from './Title';

export default Title;
